module.exports = __webpack_public_path__ + "static/media/badge-appstore.bdb20ea8.svg";